import { render, staticRenderFns } from "./SetSpeed.vue?vue&type=template&id=45119a57&"
import script from "./SetSpeed.vue?vue&type=script&lang=js&"
export * from "./SetSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports